import axios from 'axios';
import { wrapper } from 'axios-cookiejar-support';
import { CookieJar } from 'tough-cookie';
import { AuthService } from './AuthService';
import { authUserSignal } from '../signals/authSignal';
import { createLogger } from '../utils/logger';

const logger = createLogger('HttpService');

export class HTTPService {

    private httpClient;

    constructor(authService:AuthService){

        logger.debug(`HttpService base URL: ${process.env.HTTP_SERVICE_BASE_URL}`)
        //this.authService = authService;
        this.httpClient = wrapper(axios.create({ 
            jar:new CookieJar(),
            withCredentials:true,
            baseURL:process.env.HTTP_SERVICE_BASE_URL || 'http://localhost:4500/',
            //baseURL:'https://notes-api.lalotech.net/',
            /*httpsAgent: new https.Agent({  
                rejectUnauthorized: false
            })*/
            /*headers: {
                //'Origin': null,
            }*/
        }));
        /*this.httpClient.interceptors.request.use(config => {
            if(!config.headers['Authorization']){
                config.headers['Authorization'] = `Bearer ${token}`; //the token from useAuth or other global variable.
            }
            return config;
        }, (error) => Promise.reject(error);
        );*/
        this.httpClient.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data response => response
            return response;
          }, async (error) => {
            logger.debug(`interceptor in response status:${error.response?.status} url:${error.config?.url}`);
            const prevRequest = error?.config;

            if(error?.response?.status === 403 && !prevRequest.sent && prevRequest.url.indexOf('refresh_token') > 0){
                prevRequest.sent = true; 
                logger.debug(`httpClient callback for refresh_token expired on backend`)

                authUserSignal.value = undefined;

                window.location.reload();

            } else if(error?.response?.status === 403 && !prevRequest.sent){
                logger.debug(`trying refreshLogin(), url:${prevRequest.url}`);
                //refresh access token using the refresh_token
                prevRequest.sent = true; // this prevent the infinite loop for 403 error codes
                await authService.refreshLogin();
                //prevRequest.headers['Authorization'] = `Bearer ${newToken}`;
                return this.httpClient(prevRequest);
            } else if(error?.response?.status === 401) {
                //the store credentials are not valid anymore and we need to clean up and re-authenticate
                authUserSignal.value = undefined;
                //window.location.replace("/login");
            }


            return Promise.reject(error);
          });
    }
    public getClient(){
        return this.httpClient;
    }
}